import Vue from 'vue';
import App from './App.vue';
import GAuth from 'vue-google-oauth2'

const gauthOption = {
  clientId: '99715008598-n0hqoe579li3q48llt4ptqh7vkhhb5l5.apps.googleusercontent.com',
  scope: '',
  prompt: 'select_account'
}
new Vue({
  render: h => h(App),
}).$mount('#app');

Vue.use(GAuth, gauthOption)